module.exports = __webpack_public_path__ + "static/stunas-logo.5ca1dc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sponsors/stunas-logo.png
// module id = 555
// module chunks = 211492426229339